import React from 'react';
import Navbar from './component/Navbar';
import LandingPage from './container/LandingBox';
import SkillPage from './container/SkillBox';
import Jumbotron from './component/Jumbotron';
import ToolPage from './container/ToolBox';
import GithubPage from './container/Github';
import Websites from './container/WebsiteBlock';
import Blender from './container/Blender';
import Blogs from './container/Blogs';
import Footer from './container/Footer';
import AboutMe from './container/AboutMe';
import Books from './container/Books';
import ConnectPage from './container/Connect';



function App() {
  return (
    <Jumbotron flexDirection="column" margin="0px auto">
      <Navbar/>
      <LandingPage />
      <AboutMe/>
      <SkillPage/>
      <ToolPage/>
      <GithubPage/>
      <Websites/>
      <Blender/>
      <Blogs/>
      <Books/>
      <ConnectPage/>
      <Footer />
    </Jumbotron>
  );
}

export default App;
